import clsx from 'clsx'
import find from 'lodash/find'
import reduce from 'lodash/reduce'
import React, { FC, useContext, useMemo } from 'react'
import styled from 'styled-components'

import { Category } from '@Generated/graphql'
import { MetadataContext } from '@Globals/Metadata'

import { MegaMenuAllCategories } from './MegaMenuAllCategories'
import { MegaMenuSingleCategory } from './MegaMenuSingleCategory'

const categoryOne = ['13', '130', '35', '33', '68', '201', '36', '195']
const categoryTwo = ['11', '14', '6', '7', '10']
const categoryThree = ['63', '5']

const filterCategories = (
  categoriesMenu: Category[],
  categoryIDs: string[],
): Category[] => reduce(
  categoryIDs,
  (prev, categoryID) => {
    const category = find(categoriesMenu, ['id', categoryID])

    if (!category) {
      return prev
    }

    return [...prev, category]
  },
  [] as Category[],
)

interface MegaMenuProps {
  activeID?: number
  isOpen: boolean
}

const Wrapper = styled.div`
  position: absolute;
  z-index: ${({ theme }) => theme.zIndexes.desktopHeaderNavMenu};
  top: 100%;
  left: 0;
  display: flex;
  width: calc(100vw - 60px);
  max-width: ${({ theme }) => theme.breakpoints.maxWidth};
  height: 0;
  overflow: hidden;
  transition: height 0.125s ease-out;

  &.isActive {
    min-height: 480px;
    height: auto;
  }
`

export const MegaMenu: FC<MegaMenuProps> = (
  {
    activeID,
    isOpen,
  }: MegaMenuProps,
) => {
  const { categoriesMenu } = useContext(MetadataContext)

  const singleCategoryOne = useMemo(
    () => filterCategories(categoriesMenu, categoryOne),
    [categoriesMenu],
  )
  const singleCategoryTwo = useMemo(
    () => filterCategories(categoriesMenu, categoryTwo),
    [categoriesMenu],
  )
  const singleCategoryThree = useMemo(
    () => filterCategories(categoriesMenu, categoryThree),
    [categoriesMenu],
  )

  return (
    <Wrapper className={clsx({ isActive: isOpen })}>
      <MegaMenuAllCategories
        activeID={activeID}
        categories={categoriesMenu}
        menuID={0}
      />
      <MegaMenuSingleCategory
        activeID={activeID}
        categories={singleCategoryOne}
        menuID={1}
      />
      <MegaMenuSingleCategory
        activeID={activeID}
        categories={singleCategoryTwo}
        menuID={2}
      />
      <MegaMenuSingleCategory
        activeID={activeID}
        categories={singleCategoryThree}
        menuID={3}
      />
    </Wrapper>
  )
}
